import React from 'react';

const StaticAudioVisualizer = () => (
    <div className="static-audio-visualizer">
        <div className="line small-line" />
        <div className="line medium-line" />
        <div className="line small-line" />
    </div>
);

export default StaticAudioVisualizer;
